import React, { ReactNode } from 'react';

type PopoverContentProps = {
	tabIndex?: number;
	title?: string;
	children: ReactNode;
};

const PopoverContent = ({
	tabIndex = 1,
	title,
	children,
}: PopoverContentProps) => {
	return (
		<div
			tabIndex={tabIndex}
			className="text-left p-5 max-w-xs bg-white rounded-2xl inner filter shadow-leap pointer-events-auto lg:pointer-events-none outline-none">
			{title && <h3 className="font-semibold text-brand">{title}</h3>}
			<p className="text-sm text-font">{children}</p>
		</div>
	);
};

export default PopoverContent;
